export default "__VITE_ASSET__TRAgsF2___"